module.exports = __webpack_public_path__ + "static/img/phone_en_2.3a9589a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone_en_2.jpg
// module id = 361
// module chunks = 2